import { generatePath } from '@ps/web-core-utils';
import type { AddUserClubResponse } from '@ps/web-shared-api-types/v1-preview/SwHomeGames/';
import type React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';

import type { RequestError } from '@swf/core/errors/RequestError';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import {
  ClubRoute,
  ModalRoutes,
  PKR_LOADERS,
  useHomeGamesWidget,
  useJoinPublicClub
} from '@swf/poker';

const Promotion: React.FC = () => {
  const { homeGamesClubs = '' } = useSelector(select.cms.getAliases);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const hasClientSession = useSelector(select.session.hasClientSession);
  const { widgetDispatch } = useHomeGamesWidget();
  const userId = useSelector(select.account.getUserId);
  const { modal } = useDispatch<Dispatch>();
  const joinPublicClub = useJoinPublicClub();
  const { push } = useHistory();
  const {
    params: { clubId: inputClubId }
  } = useRouteMatch<{ clubId: string }>();

  useEffect(() => {
    widgetDispatch.setLoading({ isLoading: true, loaderName: PKR_LOADERS.joinPromoClub });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const clubId = Number(inputClubId);
    if (!isAuthenticated || !hasClientSession || !clubId || !userId) return;
    if (isNaN(clubId)) return push(generatePath(homeGamesClubs, {}));

    const handleJoinPublicClub = async (clubId: number) => {
      let textError = '';
      try {
        const { error } = await joinPublicClub(clubId, userId);

        if (error) {
          textError = error;
        } else {
          await widgetDispatch.fetchLobbyData({ clubId });
        }
      } catch (err) {
        const { body } = err as RequestError<AddUserClubResponse>;
        textError = body.message.includes('You are already') ? '' : body.message;
      } finally {
        if (textError)
          modal.enqueue({
            path: ModalRoutes.notification,
            locationState: { text: textError }
          });

        push(generatePath(homeGamesClubs, { clubId, section: ClubRoute.Lobby }));
        widgetDispatch.setLoading({ isLoading: false, loaderName: PKR_LOADERS.joinPromoClub });
      }
    };

    widgetDispatch.setLoading({ isLoading: true, loaderName: PKR_LOADERS.joinPromoClub });
    handleJoinPublicClub(clubId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, hasClientSession, inputClubId, userId]);

  return null;
};

export default Promotion;
